import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { PrimaryButton } from "best-common-react";

class CompHeaderDetails extends React.Component {
  render() {
    let { compStore } = this.props.rootStore;
    return (
      <div className="row align-items-center h-100 m-0 p-0">
        <div className="col-7">
          <h5>Manage Comparisons</h5>
        </div>
        <div className="col-5">
          <div className="row m-0 align-items-center justify-content-end">
            <PrimaryButton
              onClick={() => {
                compStore.openComp(0);
              }}
            >
              Create New Comparison
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

CompHeaderDetails.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(CompHeaderDetails));
